var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{attrs:{"id":"footer","data-aos":"fade"}},[_c('div',{staticClass:"container"},[_c('FooterTop'),_c('FooterBottom')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }